import {
  GET_CARDHOLDER_INFO,
  RESET_CARDHOLDER_INFO,
  SET_LAST_SECTION_VISITED,
  RESET_LAST_SECTION_VISITED
} from '../types/cardholder';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface CardholderState {
  cardholderInformation: any,
  drugOffenseAdded: boolean,
  cardholderApplication: any
}

const INITIAL_STATE: CardholderState = {
  cardholderInformation: null,
  drugOffenseAdded: null,
  cardholderApplication: {
    lastSectionVisited: 0
  }
};

const cardholderReducer = function (
  state: CardholderState = INITIAL_STATE,
  action: PayloadAction<any>
): CardholderState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_CARDHOLDER_INFO:
      return { ...state, cardholderInformation: action.payload };
    case SET_LAST_SECTION_VISITED:
      return {
        ...state,
        cardholderApplication: {
          ...state.cardholderApplication,
          lastSectionVisited: action.payload
        }
      };
    case RESET_LAST_SECTION_VISITED:
      return {
        ...state,
        cardholderApplication: {
          ...state.cardholderApplication,
          lastSectionVisited: 0
        }
      };
    case RESET_CARDHOLDER_INFO:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default cardholderReducer;
